/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FilterIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FilterIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2FilterIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#323F4B"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2FilterIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Y9kTr': alignSelf,'--mt-2-Y9kTr': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Y9kTr': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Y9kTr': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Y9kTr': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Y9kTr': opacity,'--w-10-Y9kTr': typeof width === 'number' ? `${width}px` : width,'--h-11-Y9kTr': typeof height === 'number' ? `${height}px` : height,'--f-12-Y9kTr': fill,'--a-7-Y9kTr': isAnimated ? animation : "none",'--sd-8-Y9kTr': isAnimated ? strokeDashoffset : 0,'--sd-9-Y9kTr': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2FilterIcon.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_1686_56114)"
 className="views-block"
>
<path
  data-testid="Tysiav2FilterIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.643.412a.643.643 0 100 1.286h10.714a.643.643 0 100-1.286H.643zm.824 3.297a.643.643 0 000 1.286h9.066a.643.643 0 000-1.286H1.467zm.181 3.94c0-.356.288-.644.643-.644H9.71a.643.643 0 010 1.286H2.29a.643.643 0 01-.643-.643zm1.467 2.653a.643.643 0 000 1.286h5.77a.643.643 0 000-1.286h-5.77z"
 style={{'--f-12-Y9kTr': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}